import React, { createContext, useContext, useEffect, useState } from 'react'
import { useGetHolidays } from 'utils/hooks/queries/useGetHolidays'
import { useAlert } from './AlertContext'

// const defaultHolidaysCalendar = {}

const HolidaysContext = createContext({})

const HolidaysProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [holidays, setHolidays] = useState({})
  const { data: fetchedData, isSuccess, isError } = useGetHolidays()
  const { displayAlert } = useAlert()

  useEffect(() => {
    if (isSuccess && fetchedData) {
      setHolidays(fetchedData as typeof holidays)
      return
    }
    if (isError) {
      displayAlert('Error while fetching holidays', 'error')
    }
  }, [isSuccess, fetchedData])

  return <HolidaysContext.Provider value={holidays}>{children}</HolidaysContext.Provider>
}

const useHolidays = () => {
  return useContext(HolidaysContext)
}

export { HolidaysProvider, useHolidays }
